import { Role } from 'common/types/Entities';

import { _request,APIBaseResponse, APIMethod } from '../index';

const TENANTS_PATH_PREFIX = '/tenants';
const USERS_PATH_PREFIX = 'users';
const ROLES_PATH_PREFIX = 'roles';

type APIUserRolesListParams = {
    tenantId: string;
    userId: string;
};

type APIUserRolesListResponse = APIBaseResponse<Array<{
    userId: string;
    tenantId: string;
    userGroupId?: string;
    userGroupName?: string;
    role: Role;
}>>;

export const APIUserRolesGetList: APIMethod<APIUserRolesListParams, APIUserRolesListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}/${ROLES_PATH_PREFIX}`)
);
